
import { productAddToCartButtonStyles } from "@insite/content-library/Components/ProductAddToCartButton";
import { css } from "styled-components";


productAddToCartButtonStyles.css = css`
    font-size: .9em;
    background: #ed1c24 0% 0% no-repeat padding-box;
    box-shadow: 3px 3px 6px #00000029;
    border: 1px solid #707070;
    border-radius: 7px;
    opacity: 1;
    color: white;
    
    &:hover {
        opacity: .9;
        background: #ed1c24 0% 0% no-repeat padding-box;
        border: 1px solid #707070;
    }
`;